import React, { Fragment } from "react";
import {
  Button,
  TextInput,
  Form,
  useNotify,
  useRefresh,
  useDataProvider,
  SaveButton
} from "react-admin";
import { useWatch } from "react-hook-form";
import IconContentAdd from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { CopyBlock, dracula } from "react-code-blocks";

const Save = ({setTokenCallback}) => {
  const notify = useNotify();
  const dataprovider = useDataProvider();
  
  const nickname = useWatch({ name: 'p_nickname' }); 
  
  const handleSave = () => {

    return dataprovider.insertAPIKey(nickname)
    .then((e) => {
      console.log(e)
      setTokenCallback(e.token);
    })
    .then((e) => {
      notify("New API Key Added", "info", { smart_count: 1 });
    })
  };
  return <SaveButton onClick={handleSave}/>
}

const APIKeyQuickCreateButton = (props) => {

  const refresh = useRefresh();
  const [showDialog, setShowDialog] = React.useState(false);
  const [token, setToken] = React.useState(null);

  return (
    <Fragment>
      <Button onClick={() => setShowDialog(true)} label="ra.action.create">
        <IconContentAdd />
      </Button>

      <Form resource={`profile`}>
        <div>
          <Dialog
            fullWidth
            open={showDialog}
            aria-label="Create API Key"
            style={{ zIndex: 1 }}
          >
            <DialogTitle>{(!token) ? 'Create Key' : 'Your API Key'}</DialogTitle>
            <DialogContent>
              {(!token) && <TextInput source="p_nickname" label="Nickname"/>}
              {(token) && (
                <div>
                  <Typography variant="h6">Please note:</Typography>
                  <Typography variant="p">This token will not be shown again. Please keep it in a safe location and do not share it with anyone. This key will be valid for 3 years.</Typography>
                  
                  <div style={{height:'1em'}}/>                    
                  <div sytle={{ wordWrap: 'break-word'}}>
                      <CopyBlock
                          text={token}
                          language={'text'}
                          showLineNumbers={false}
                          wrapLines
                          theme={dracula}
                          />
                  </div>
                  
                </div>
              )}
            </DialogContent>
            <DialogActions
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              {!token && (
                <Button
                  label="Cancel"
                  color="secondary"
                  onClick={() => setShowDialog(false)}
                />
              )}
              {!token && (
                <Save setTokenCallback={(_token) => {
                  console.log('setting token', _token);
                  setToken(_token)
                }}/>
              )}
              {token && (
                <Button
                  label="Close"
                  color="primary"
                  onClick={() => {
                    setShowDialog(false);
                    refresh();
                  }}
                />
              )}
            </DialogActions>
          </Dialog>
        </div>
      </Form>
    </Fragment>
  );
};

export default APIKeyQuickCreateButton;
